import { Line, mixins } from 'vue-chartjs'

export default Line.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
        this.chartOptions = {
            layout: {
              padding: {
                  top: 5
              }
            },
            responsive: true,
            elements: {
                line: {
                    tension: 0
                }
            },
            legend: {
              display: true,
              position: 'right',
              labels: {
                boxWidth: 12,
                usePointStyle: true
               }
            },
            maintainAspectRatio: false,
            scales: {
                yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    display:true,
                    ticks: {
                      display: false,
                      beginAtZero: true
                    }
                }],
                xAxes: [ {
                    gridLines: {
                        display: false
                    }
                }]
            }
        };

        this.renderChart(this.chartData, this.chartOptions);
    }
});



// WEBPACK FOOTER //
// ./src/tools/charts/SalesDaily.js